import classNames from 'classnames';
import Button from 'react-bootstrap/Button';
import { Heart } from 'components/Icons';
import { MouseEventHandler, useCallback, useState } from 'react';
import './HeartButton.css';

export type HeartButtonProps = {
  isLiked: boolean;
  className?: string;
  likesCount: number;
  onClick: MouseEventHandler
};

export const HeartButton = ({ isLiked, className, likesCount, onClick }: HeartButtonProps) => {
  const [isBouncing, setIsBouncing] = useState(false);

  const onButtonClick = useCallback((e) => {
    if (!isLiked) {
      setIsBouncing(true);
    }
    onClick(e);
  }, [isLiked, onClick]);


  const onAnimationEnd = useCallback(() => {
    setIsBouncing(false);
  }, []);

  return (
    <Button
      variant="link"
      className={
        classNames(
          "heart-button d-flex align-items-center text-decoration-none text-secondary p-0",
          className,
          {
            'heart-button-liked': isLiked,
            'heart-button-is-bouncing': isBouncing,
          }
        )
      }
      onClick={onButtonClick}
    >
      {likesCount > 0 && <small className="me-2">{likesCount}개</small>}
      <Heart fill={isLiked} onAnimationEnd={onAnimationEnd} />
    </Button>
  );
};
